import { defineSlotRecipe } from '@chakra-ui/react';
import { alertAnatomy } from '@chakra-ui/react/anatomy';

/** KDS Alert — Kintsugi Design System node 193:1159. */
export const alertSlotRecipe = defineSlotRecipe({
  slots: alertAnatomy.keys(),
  base: {
    root: {
      alignItems: 'center',
      gap: '3',
      px: '4',
      py: '3',
      borderRadius: 'md',
      color: 'colorPalette.fg',
    },
    indicator: {
      color: 'colorPalette.fg',
      '& svg': {
        width: '20px',
        height: '20px',
      },
    },
    content: {
      // Figma: `sm` (8px) between the title+description block and optional link — not between title and description.
      gap: '2',
      minW: 0,
    },
    title: {
      textStyle: 'large.medium',
      color: 'neutral.500',
    },
    description: {
      textStyle: 'default.regular',
      color: 'neutral.350',
    },
  },
  variants: {
    status: {
      info: {
        root: { colorPalette: 'blue', bg: 'blue.100' },
      },
      warning: {
        root: { colorPalette: 'orange', bg: 'orange.100' },
      },
      success: {
        root: { colorPalette: 'green', bg: 'green.100' },
      },
      error: {
        root: { colorPalette: 'red', bg: 'red.100' },
      },
    },
  },
});
